import { api } from './Api'

export function getInitData(){
    return (
        api.get(`GetInitData`)
    )
}

export function getComboData(godina){
        if (window.kconfig.transparentnost.dev){
            return ( api.get(`GetComboData/${godina}`) )
        }else{
            return ( api.get(`GetComboData&godina=${godina}`) )
        }
}

export function getSearchData(obj){
    return (
        api.post(`GetSearchData`, obj)
    )
}

export function getSearchXls(obj){
    return (
        api.post(`GetSearchXls`, obj)
    )
}

export function getSearchCsv(obj){
    return (
        api.post(`GetSearchCsv`, obj)
    )
}

export function getSearchXml(obj){
    return (
        api.post(`GetSearchXml`, obj)
    )
}